export default __webpack_public_path__ + "static/media/HTS-Logo.f2afcddf.png";